export const DEFAULT_PLACEHOLDER = {
  light:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN88erDfwAJRwPDhElpxQAAAABJRU5ErkJggg==',
  dark:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNs79/RBwAF0QJeORWL3gAAAABJRU5ErkJggg==',
};
